import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
/**
 * A compact "Lv. 7 · Regular" pill.
 */
export default class LevelBadge extends Component {
  view() {
    const {
      user,
      showTitle = true
    } = this.attrs;
    const level = user.attribute('level');
    if (!level) return null;
    const title = user.attribute('levelTitle');
    const tooltip = app.translator.trans('hawer-s-level.forum.badge_tooltip', {
      level,
      xp: user.attribute('levelXp')
    }, true);
    return m(Tooltip, {
      text: tooltip
    }, m("span", {
      className: 'SLevelBadge ' + (this.attrs.className || '')
    }, m("span", {
      className: "SLevelBadge-level"
    }, app.translator.trans('hawer-s-level.forum.badge_label', {
      level
    })), showTitle && title ? m("span", {
      className: "SLevelBadge-title"
    }, title) : null));
  }
}
flarum.reg.add('hawer-s-level', 'forum/components/LevelBadge', LevelBadge);